import { render, staticRenderFns } from "./OptionCategory.vue?vue&type=template&id=77be8a62&"
import script from "./OptionCategory.vue?vue&type=script&lang=js&"
export * from "./OptionCategory.vue?vue&type=script&lang=js&"
import style0 from "./OptionCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports